import config from 'controllers/config';
import { useSnackbar } from 'hooks';
import { IQuestionnaireAnswers } from 'pages/forms/hooks/useAnswerManager/types';
import { useCallback, useState } from 'react';
import { useApi } from 'services/api';

interface IProps {
  toast: ReturnType<typeof useSnackbar>;
}
export const useAnswerFormFetcher = ({ toast }: IProps) => {
  const [isSubmitDataLoading, setIsSubmitDataLoading] = useState(false);
  const submitData = async (body: IQuestionnaireAnswers) => {
    const { api } = useApi();

    const backendUrl = config.API_NODE;
    if (backendUrl) {
      const headers = { userfunctionkey: 'c80a0ae7cdf09e28c72e949ee37df341' };
      const result = await api.post(`${backendUrl}/forms/answer`, body, { headers });
      return result.data;
    }
  };
  const submitAnswers = useCallback(async (body: IQuestionnaireAnswers) => {
    setIsSubmitDataLoading(true);
    await submitData(body)
      .then(() => {
        toast.toggleSnackbar({
          message: 'Formulário respondido com sucesso!',
          type: 'success',
          duration: 1500
        });
      })
      .catch((error) => {
        const defaultMessage = 'Ocorreu um erro ao tentar salvar formulário!';
        toast.toggleSnackbar({
          message: error.response?.data?.message || defaultMessage,
          type: 'error'
        });
      })
      .finally(() => setIsSubmitDataLoading(false));
  }, []);

  return { submitAnswers, isSubmitDataLoading };
};
